import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper/";
import media from "styled-media-query";
import { HeaderLinkStyle as HeaderLink } from "BaseComponents/Link/BaseLink";
import { Paragraph } from "BaseComponents/Text";
import { StyledBackgroundImage } from "Framework/lazy/StyledBgImage";
import { VideoContainer } from "Components/Video";

export const VideoHitWrapper = styled(VideoContainer)`
	${media.greaterThan(breakpoints.mobile)`
	margin: 20px 0 0 20px;
	
	width: 100%;
	height: 200px;
`}
	margin: 10px 0;
`;
export const SearchTopWrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.lightgreen};
	width: 100%;
`;

export const SearchTop = styled.div`
	margin: 0 auto;
	max-width: 940px;
	display: flex;
	flex-direction: column;
	padding: 0rem 1rem 1rem 0rem;
	${media.greaterThan(breakpoints.ipad)`
	padding: 3rem 1rem;

	flex-direction: row;
    padding: 20px 0 50px 0;
    `}
`;

export const SearchInputWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 2rem 0 0 0;
`;

export const HitsWrapper = styled.div`
	max-width: 1170px;
	padding: 1rem 0;
	/* margin: 2rem auto; */
	${media.greaterThan(breakpoints.mobile)`
	margin: 0 -20px;
	`}
	display: flex;
	flex-wrap: wrap;
`;
export const H2 = styled.h2`
	${media.greaterThan(breakpoints.mobile)`
	font-size: 24px;
    line-height: 30px;
`}	
	span {
		border-bottom: 2px solid transparent;
		transition: 0.2s ease;
		hyphens: auto;
		-webkit-hyphens: auto;
		-ms-hyphens: auto;

		/* Ensure words can break at appropriate points */
		overflow-wrap: break-word;
		word-wrap: break-word;

		/* Prevent single letter breaks at the end of lines */
		word-break: normal;
	}

	margin: 0.5rem 0px;
	display: block;
	font-weight: bold;
	color: black;
	font-size: 20px;
	line-height: 26px;
`;

export const HitWrapper = styled.a`
	display: flex;
	flex-direction: column;
	margin: 1rem 0;
	cursor: pointer;
	&:hover {
		h2 {
			span {
				transition: 0.2s ease;
				border-color: black;
			}
		}
	}

	${({ isLoaded }) =>
		isLoaded &&
		`
        opacity: 1;
        transform: translateY(0);
    `}

	${media.greaterThan(breakpoints.ipad)`
        /* flex-direction: row; */
  `}

    &:hover, &:focus {
		${HeaderLink} {
			span {
				border-color: black;
			}
		}
		${StyledBackgroundImage} {
			opacity: 0.7;
		}
	}
`;

export const HitImageWrapper = styled.div`
	flex-basis: 26%;
	flex-grow: 1;
	position: relative;

	${media.greaterThan(breakpoints.ipad)`
        flex-grow: 0;
        min-height: auto;
	/* min-height: 194px; */

  `}
`;

export const HitTextWrapper = styled.div`
	flex-basis: 60%;
	flex-grow: 1;
	border: 1px solid ${({ theme }) => theme.colors.grey};
	padding: 1rem;

	${media.greaterThan(breakpoints.ipad)`
        padding: .5rem 1rem;
    `}
`;

export const HitMetaDataWrapper = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const HitCategory = styled(Paragraph)`
	& {
		margin: 0;
		font-size: 14px;
		/* text-transform: uppercase; */

		&:before {
			content: "";
			display: inline-block;
			width: 8.7px;
			height: 8.7px;
			background-color: ${({ theme }) => theme.colors.secondary};
			margin: 0 5px 0 0;
		}
	}
`;

export const HitDate = styled(Paragraph)`
	& {
		font-size: 14px;
	}
`;

export const NoHitsTextParagraph = styled(Paragraph)`
	& {
		font-size: 18px;
		max-width: 940px;
		margin: 0 auto;
		display: block;
	}
`;
export const OuterWrapper = styled.div`
	display: flex;
	width: 100%;
	font-family: ${({ theme }) => theme.font};
	flex-direction: column;
	margin: 3rem 0 0 0;

	${media.greaterThan(breakpoints.ipad)`
    flex-direction: row;
    margin: 2rem 0 1rem 0;
  `}
`;

export const InnerWrapper = styled.div`
	flex-basis: 30%;
	flex-grow: 1;
	display: flex;
	flex-direction: column;

	& + & {
		margin: 1rem 0 0 0;
	}

	${media.greaterThan(breakpoints.ipad)`
    flex-basis: 30%;
    flex-grow: 0;
    & + & {
      margin: 0 0 0 1rem;
    }
  `}
`;

export const DropdownLabel = styled.span`
	font-weight: bold;
	margin: 0 0 5px 0;
	color: black;
	font-size: 16px;
`;
